
import axios, { AxiosResponse } from "axios";
import { Component, Prop, Vue } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import WsdlService from "@/services/WsdlService";
import Option from "@/models/SelectOption";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import FundType from "@/models/WsdlResponses/FundType";
import UmbracoApiService from "@/services/UmbracoApiService";
import MiInversionModel from "@/models/MiInversion/MiInversionModel";
@Component({})
export default class TuEstadoCuentaForm extends Vue {
  @Prop() isProcessing: boolean;

  public tiposDeFondos: Array<Option<FundType>> = [];
  public tipoFondo: FundType = new FundType();
  public fechaCortes: Array<Option<any>> = [];
  public fechaCorte: any = {};
  public todaysDate: Date = new Date();
  public wsdlService: WsdlService = new WsdlService();
  public userId: string = this.$store.state.user.cedula;

  constructor() {
    super();
  }

  public umbracoService = new UmbracoApiService();
  public miInversion = new MiInversionModel();

  async mounted() {
    try {
      await this.getData();
    } catch (error) {
      console.error("Error en getData:", error);
    } finally {
      await this.getDropdownData();
    }
  }

  public async getDates() {
    this.wsdlService
      .GetDataCortesEDC(this.tipoFondo.tipofondo, this.tipoFondo.codcuenta)
      .then((response: AxiosResponse<any>) => {
        response.data.forEach((data) => {
          let option = new Option<any>();
          option.value = data;
          option.text = data.periodo;
          option.disabled = false;
          this.fechaCortes.push(option);
        });
        this.fechaCorte = this.fechaCortes[0].value;
      });
  }
  async getDropdownData() {
    this.wsdlService
      .getTipoDeFondos(this.userId, "")
      .then((response: AxiosResponse<FundTypeObj>) => {
        let option = new Option<FundType>();
        option.value = response.data.tipofondos;
        option.text = response.data.tipofondos.valor;
        option.disabled = false;
        this.tiposDeFondos.push(option);
        this.tipoFondo = option.value;
        this.getDates();
      });
  }
  async getData() {
    this.miInversion = await this.umbracoService.getMiInversion();
  }
  public process() {
    this.$emit("process", this.tipoFondo, this.fechaCorte);
  }
  returnHome() {
    window.location.href = GlobalConfig.PORTAL_BASE_URL;
  }
}
